import { css } from "@emotion/react";
import PopUp from "@/modules/ui-elements/PopUp";
import { getPaymentList } from "src/services/payment";
import { useCallback, useEffect, useState } from "react";
import { Skeleton } from "@mui/material";
import useAuth from "@/hooks/useAuth";
import useToast from "@/hooks/useToast";
import { useAtomValue, useSetAtom } from "jotai";
import { isProFeatureClickedAtom, isRemoveWatermarkClickedAtom, showLoginPopupAtom } from "../editor-v2/Atoms";
import { ICONS } from "../ui-elements/Icon";
import currencyData from "src/utils/currencyData";


const Subscription = ({ popUpRef }) => {
  const {user:userData} = useAuth();
  const Toast=useToast();
  const isProFeatureClicked = useAtomValue(isProFeatureClickedAtom);
  const setProFeatureClicked = useSetAtom(isProFeatureClickedAtom);
  const setShowLoginPopupAtom = useSetAtom(showLoginPopupAtom);
  const setIsRemoveWatermarkClicked = useSetAtom(isRemoveWatermarkClickedAtom);
  const [paymentListData, setPaymentListData] = useState({});

  const paymentListHandler = async () => {
    try {
      const response = await getPaymentList();
      setPaymentListData(response.data.data ?? {});
    } catch (error) {
      console.error("error in fetching paymentList");
    }
  };

  const startSubscriptionHandler = () => {
    setShowLoginPopupAtom(true);
    setProFeatureClicked(false);
    popUpRef.current?.close();
  };

  const createDesignHandler = () => {
    window.location.href=`${window.location.origin}/dashboard/editor`;
    popUpRef.current?.close();
  };

const paymentCallback = useCallback(()=>{
  paymentListHandler();
},[userData?.user?._id]);

  useEffect(()=>{
    if(isProFeatureClicked){
      popUpRef.current.open();
      setProFeatureClicked(false);
    }
    if(userData?.user?._id)paymentCallback();

  },[isProFeatureClicked,userData?.user?._id]);

  const onPopUpBackDropAndCloseButtonClick = () => {
    setIsRemoveWatermarkClicked(false)
  }

  return (
    <PopUp ref={popUpRef} onBackdropClick={onPopUpBackDropAndCloseButtonClick} onCloseButtonClick={onPopUpBackDropAndCloseButtonClick} width={600} styleBody={{ padding: "0" }}>
      <div css={styles.container}>
        <div css={styles.title}>{ (userData?.user?._id && userData?.user?.login_type !== 'Guest') ? paymentListData?.Congratulations || 'You are a DoMyShoot Premium Member' : paymentListData?.doMyshootPremium}</div>
        <div css={styles.alertContainer}>
          <img src={ICONS.partyPopper} width='24px' height='24px' />
           <span>{paymentListData?.expiryDateKey ? paymentListData?.expiryDateKey : <Skeleton width='300px' height='25px' />}</span> 
        </div>
        <div css={styles.bottomContainer}>
          <div css={styles.bottomContent}>
          <h4 style={{display: 'flex'}}><img src={ICONS.unlock} width='24px' height='24px' />{ (userData?.user?._id && userData?.user?.login_type !== 'Guest') ?'Features:': paymentListData?.unlock}</h4>
          {paymentListData?.featuresList?.length > 0 ? 
            paymentListData?.featuresList?.map((text) => (
              <div css={styles.featureBox}>
                <img
                  src={"/icons/settings/check.svg"}
                  style={{ width: "12px", height: "12px" }}
                />
                <span css={styles.featureBoxText}>{text}</span>
              </div>
            )) : <div>
              {Array(7).fill(0).map(()=><Skeleton width='350px' height='25px' />)}</div>}          
              {paymentListData?.planData?.length > 0 ? 
            paymentListData?.planData?.map((item) => (
              <>
                {item?.visibility ? 
                   item?.Recommended_plan ? (
                  <div
                    css={[styles.btnProStyle,styles.blackBorder]}
                  >
                    <div css={styles.btnProStyleLeft}>
                      <span css={[styles.btnProStylePinkText,styles.btnProStyleBlack]}>
                        <span css={styles.btnProStylePinkTextCut}>{currencyData[item?.plan_detail.currency]?.symbol}{item?.planCta}</span>{" "}
                        <span css={styles.btnProStylePinkText}>{paymentListData?.ctaFree}</span>
                      </span>
                    </div>
                    <img
                      src={paymentListData?.greyTickIcon}
                      style={{ width: "16px", height: "16px" }}
                    />
                  </div>
                ) : <></> : <></>}
                 </>
            )) : <div>{Array(1).fill(0).map(()=><Skeleton width='350px' height='65px' />)}</div>}
            <div css={styles.freeAccessText}>{paymentListData?.expiryDateKey}</div>
            {(userData?.user?._id && userData?.user?.login_type !== 'Guest') ? 
              <button css={styles.button} onClick={createDesignHandler}>Create a Design</button>
            : <button css={styles.button} onClick={startSubscriptionHandler}>{paymentListData?.startFreeTrial || "Start Free Trail"}</button>
            }
          </div>
        </div>
      </div>
    </PopUp>
  );
};

const styles = {
  container: css`
    display: flex;
    flex-direction:column;
  `,
  title: css`
    color: #262626;
    font-family: "Objectivity";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 160%;
    width:100%;
    text-align:center;
    padding-top:60px;
    padding-bottom:16px;
  `,
  alertContainer:css`
  display: flex;
  width:100%;
  padding: 8px 0px;
  font-size:14px;
  color:#5F2EE5;
  font-weight:600;
  gap:8px;
  justify-content: center;
  align-items: center;
  background:#F3EEFF;
  span{
    align-self:end;
  }
  `,
  bottomContainer:css`
  display:flex;
  justify-content:center;
  padding-top:24px;
  padding-bottom:60px;
  `,
  bottomContent:css`
  display:flex;
  width:100%;
  max-width:370px;
  flex-direction:column;
  gap:8px;
  align-items:flex-start;
  h4{
    width:100%;
  }
  `,
  
  featureBox: css`
    display: flex;
    width:100%;
    gap: 8px;
    align-items: center;
  `,
  featureBoxText: css`
    font-size: 12px;
    color: #262626;
    font-family: "Objectivity";
    font-style: normal;
    font-weight: 400;
    align-self: end;
  `,
  btnProStyle: css`
  display: flex;
  width:100%;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  background: #fff;
  padding: 16px;
  border: 2px solid #ed3175;
  cursor: pointer;
`,
blackBorder:css`
border:1px solid #000000;
`,
btn1Style: css`
    border-radius: 8px;
    border: 1px solid #eee;
    padding: 16px;
    font-weight: 600;
    cursor: pointer;
    width:100%;
  `,
  freeAccessText:css`
  display:flex;
  width:100%;
  justify-content:center;
  color: #5F2EE5;
  text-align: center;
  font-family: 'Objectivity';
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 170%;
  `,
  btnProStyleLeft: css`
    display: flex;
    flex-direction: column;
  `,
  btnProStylePinkText: css`
    color: #ed3175;
    font-family: "Objectivity";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 160%;
  `,
  btnProStyleBlack:css`
  color:#000000;
  `,
  centerText:css`
  width:100%;
  text-align:center;`,
  btnProStylePinkTextCut: css`
    text-decoration: line-through;
  `,
  btnProStylesubtitleText: css`
    color: #262626;
    font-family: Objectivity;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 160%;
  `,
  button: css`
    display: flex;
    width: 100%;
    padding: 18px 0px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    color: #fff;
    font-weight: 600;
    font-family: "Objectivity";
    font-size: 14px;
    border: none;
    cursor: pointer;
    background: linear-gradient(158deg, #f03750 0%, #eb2e83 100%);
  `,
};

export default Subscription;
